import { FilterCriteria, FilterStore } from 'components/Filters/FilterStore'
import { MobileDropdown } from 'components/MobileDropdown'

const criteriaOptions = [
  { label: 'All', value: 'all' },
  { label: 'One', value: 'one' },
  { label: 'Neither', value: 'neither' },
]

type Props = {
  filterStore: FilterStore
}

export function MobileFilterCriteriaSelect({ filterStore }: Props) {
  const { setPendingCriteria, pendingCriteria } = filterStore()

  return (
    <div className="border-top">
      <div className="flex items-center justify-start">
        <span className="text-gray-400 text-xs">Show results matching</span>
        <MobileDropdown
          label={
            criteriaOptions.find((o) => o.value === pendingCriteria)?.label ||
            'Select'
          }
          value={pendingCriteria}
          labelPrefix=""
          options={criteriaOptions}
          onChange={(value) => setPendingCriteria(value as FilterCriteria)}
        />
        <span className="text-gray-400 text-xs">
          of the following criteria:
        </span>
      </div>
    </div>
  )
}
